<template>

    <multiselect v-model="selected"
                :options="options"														
                :label="label"
                :track-by="trackBy" 

                selectLabel=""
                selectedLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""               
                
                open-direction="openDirection"
                :show-labels="false"

                :placeholder="placeholder"														
                :preselect-first="preselectFirst"
                :multiple="multiple"

                v-on:input="onItemSelected">

		<template v-if="tagColor" 
				  slot="tag" 
				  slot-scope="props">

			<span class="multiselect__tag" :style="'background-color:' + props.option.Color">
				<span>{{props.option.Text}}</span>
				<i aria-hidden="true" 
				   tabindex="1" 
				   class="multiselect__tag-icon" 
				   v-on:click="deleteTag(props.option.Id)"/>
			</span>
		</template>
	
		<template slot="singleLabel" slot-scope="props">

			<b-img rounded  
				   class="option__image"  
				   v-bind="propsImg" 
				   :blank-color="props.option.Color" />

			<span class="option__desc">
				<span class="option__title">{{ props.option[label] }}</span>
			</span>
		</template>

		<template slot="option" slot-scope="props">			

			<div class="option__desc">
				<b-img 	class="option__title" 
						v-bind="propsImg" 
						:blank-color="props.option.Color">
				</b-img>
				<span class="option__small" style="margin: 5px">{{ props.option[label] }}</span>						
			</div>
		</template> 

	</multiselect>

</template>

<script>

import '@/assets/styles/shared/vue-multiselect.min.css'

export default {
     model:{
        prop: 'value',
        event: 'select'
    },
    props:{
		value: [Object, Array],
        options: Array,
		label: {
			type: String,
			default: "Text"
		},
		trackBy: {
			type: String,
			default: "Id"
		},
		preselectFirst: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ""
		},
		tagColor: {
			type: Boolean,
			default: false
		},
		openDirection: {
			type: String,
			default: ""
		}
    },
    data: function(){
        return{
            propsImg: {blank: true, width: 15, height: 15},
            selected: this.value
        };
    },
    methods: {
        onItemSelected: function(value){			
            this.$emit('select', value);
        },
		deleteTag: function(id){
			this.selected.splice(this.selected.findIndex(e => e.Id == id), 1);
			this.onItemSelected(this.selected);
		}
	},
	watch: {
		'value': function(val) {
			this.selected = val;
		}
	}
}
</script>